module.exports = __webpack_public_path__ + "img/stoofvlees_meat.27b444d6.jpg";